import type { TestListItem } from '../types/test-types';

export function getStatusLabel(status: TestListItem['status']): string | null {
  switch (status) {
    case 'idle':
      return null;
    case 'running':
      return 'Running';
    case 'vulnerable':
      return 'Vulnerable';
    case 'not_vulnerable':
      return 'Not Vulnerable';
    case 'error':
      return 'Error';
    case 'impossible':
      return 'Skipped';
    default:
      return null;
  }
}

export function getStatusTooltip(status: TestListItem['status']): string | null {
  switch (status) {
    case 'vulnerable':
      return 'Security vulnerability was detected';
    case 'not_vulnerable':
      return 'No vulnerability found';
    case 'error':
      return 'Test failed due to a code error';
    case 'impossible':
      return 'Test could not run — target unreachable, timed out, or missing credentials';
    default:
      return null;
  }
}
